import { AfterViewInit, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from "@angular/router";

import { FormControlDefinition } from 'src/app/model/FormControlDefinition';
import { UserService } from 'src/app/services/user/user.service';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth/auth.service';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-forgot-password-page',
    templateUrl: './forgot-password-page.component.html',
    styleUrls: ['./forgot-password-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordPageComponent implements OnInit, AfterViewInit {
  public forgotPasswordFormGroup: FormGroup = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email])
  });

  public forgotPasswordFormDefinition: FormControlDefinition[] = [
    {
      title: "Email",
      name: "email",
      type: "email",
      placeholder: "Your email",
      control: this.forgotPasswordFormGroup.controls["email"],
      editable: true,
    }
  ];

  isSubmitting: boolean = false;

  constructor(
    private readonly _userService: UserService,
    private readonly _toastrService: ToastrService,
    private readonly _router: Router,
    private readonly _authService: AuthService,
  ) { }

  ngOnInit(): void {
    if (this._authService.authenticated) {
      this._router.navigate([this._userService.defaultNavPath]);
    }
  }

  ngAfterViewInit(): void {
    if (this._authService.authenticated) this._router.navigate([this._userService.defaultNavPath]);
  }

  public forgotPassword() {
    if (this.forgotPasswordFormGroup.invalid) return;

    this.isSubmitting = true;

    const email: string = this.forgotPasswordFormGroup.value.email;
    this._userService.requestPasswordReset(email).pipe(
      finalize(() => setTimeout(() => this.isSubmitting = false, 500))
    ).subscribe({
      next: () => {
        this._toastrService.success('If your email is registered, a password reset link has been sent!');
        this.forgotPasswordFormGroup.reset();
      },
      error: (error) => {
        this._toastrService.error('Failed to send password reset request. Please try again.');
        this.forgotPasswordFormGroup.reset();
      }
    });
  }
}
